import styled from "styled-components";
import {Field, Filter, PrimitiveObject, RefCondition, SqlOperation, SqlOperationInfo, TableI} from "../../../Types";
import {refConditionToFilters} from "./RefValueUI";
import React, {useMemo, useState} from "react";
import {schemas} from "../../../config";
import {LANG} from "../../CONSTANTS";
import {getRefConditionValue} from "./RefConditionValue";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearchengin} from "@fortawesome/free-brands-svg-icons";
import {useFadeIn} from "../../hooks/useFadeIn";
import {faAnglesRight} from "@fortawesome/free-solid-svg-icons";
import {useAppDispatch} from "../../../hooks";
import {fetchTableByQuery, setActiveTable, setTableFilters} from "../../../features/tableSlice";
import {nanoid} from "@reduxjs/toolkit";

interface PropsI {
    currentTable: string,
    table: string,
    condition: RefCondition[],
    currentSchema: TableI,
    schema: TableI,
    record: PrimitiveObject,
    closeSearch: () => void,
    setExtended: (index: number) => void,
    index: number,
    isMasked: boolean
    isExtended: boolean
}

export default function SearchRefEntry({
                                           table,
                                           condition,
                                           schema,
                                           currentSchema,
                                           record,
                                           currentTable,
                                           closeSearch,
                                           index,
                                           setExtended,
                                           isMasked,
                                           isExtended
                                       }: PropsI) {

    const filters = refConditionToFilters(condition, record);


    const dispatch = useAppDispatch();

    const {fields, foreignFields} = useMemo(() => {
        const fields = Object.fromEntries(currentSchema.fields.map(f => ([f.key, f])));
        const foreignFields = Object.fromEntries(schema.fields.map(f => ([f.key, f])));
        return {
            fields: fields,
            foreignFields: foreignFields
        }
    }, [currentSchema.fields, schema.fields]);

    function searchRef(fields: Record<string, Field>, foreignFields: Record<string, Field>) {
        dispatch(setActiveTable(table))
        dispatch(setTableFilters(filters.map(f => ({
            ...f,
            locked: true,
            nanoid: nanoid(),
            type: fields[f.field]?.type || foreignFields[f.field].type
        }))))
        dispatch(fetchTableByQuery({clean: true, pageIndex: 1}))
        closeSearch()
    }


    return <Container>
        <div className="search-ref-title text-ellipsis">
            <button className="search-ref-button btn-cmn text-ellipsis" onClick={() => searchRef(fields, foreignFields)}>
                <div className="table text-ellipsis">
                    {schema.title[LANG]}
                </div>
                <FontAwesomeIcon icon={faSearchengin} className={'fa-secondary-color-text'} title={"Шукати"}
                                 style={{width: "1.2rem", height: "1.2rem", rotate: "y 180deg"}}/>
            </button>
            <button className={"search-ref-expand btn-cmn"} onClick={() => setExtended(isExtended ? -1 : index)}>
                <FontAwesomeIcon icon={faAnglesRight} className={'fa-secondary-color-text'}
                                 title={"Відкрити фільтри"}
                                 style={{
                                     width: "1.2rem",
                                     height: "1.2rem",
                                     rotate: isExtended ? "y 180deg" : "y 0deg"
                                 }}/>
            </button>
        </div>

        <div className="filters">
            {filters.map((f, i) => <FilterRep f={f} field={fields[f.field] || foreignFields[f.field]!} key={i}/>)}
        </div>
        {isMasked && <div className="mask"/>}
    </Container>
}

export const FilterRep = ({f, field}: { f: Filter, field: Field }) => {

    let name = field.title[LANG]
    let nullOP = f.filterOp === SqlOperation.IS_NOT_NULL || f.filterOp === SqlOperation.IS_NULL;

    return <FilterContainer>
        <div className="filter-rep-head">
            <div title={name} className={'name'}>{name}</div>
            <div className={'divider'}>&nbsp;|&nbsp;</div>
            {nullOP ? <div className={'null'}>{SqlOperationInfo[f.filterOp].ua}</div> :
                <div className={'op'}>{SqlOperationInfo[f.filterOp].ua}</div>}
        </div>
        <div
            className="filter-rep-val text-ellipsis">{getRefConditionValue(field, f.value)}</div>
    </FilterContainer>
}

const FilterContainer = styled.div`
    display: flex;
    flex-flow: column;

    border: 2px solid var(--table-border-color);

    & .filter-rep-head {
        padding: .2rem;
        display: flex;
        gap: .2rem;
        justify-content: center;
        border-bottom: 2px solid var(--table-border-color);
    }

    & .filter-rep-val {
        padding: .2rem;
        text-align: center;
    }
`

const Container = styled.div`
    display: flex;
    flex-flow: column;

    min-width: 200px;
    max-width: 300px;
    width: 100%;

    position: relative;

    background-color: var(--table-row-odd-bg-color);
    padding: .2rem;

    & .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
    }

    & .search-ref-title {
        display: flex;
        border: 2px solid var(--table-border-color);
        border-bottom: none;

    }

    & .search-ref-button {
        padding: .2rem;
        //border-radius: .2rem 0 0 0;
        border-radius: 0;
        display: flex;
        gap: .5rem;
        justify-content: center;
        flex: 1 1 auto;
    }

    & .search-ref-expand {
        flex: 0 0 auto;
        padding: .2rem;
        //border-radius: 0 .2rem .2rem 0;
        border-radius: 0;
        border-left: 2px solid var(--table-border-color);
    }

    //padding-bottom: .2rem;
    //border-bottom: 2px solid var(--table-action-color);
`
